import React from "react";
import { connect } from "react-redux";
import { GetConfiguration } from "./action";
import { GetSummary } from "./action";
import { Button, Glyphicon } from "react-bootstrap";
import ReactJson from "react-json-view";
import Loader from "../../Loader/index";
import { getFamilyUnitVersionInConfigurations } from "helper/utils";

class Details extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
    };
  }

  componentDidMount() {
    const id = this.props.match.params.id;
    const { dispatch } = this.props;

    dispatch(GetConfiguration(id)).then((configuration) => {
      const familyUnitTypes = getFamilyUnitVersionInConfigurations(
        configuration.configurations
      );
      dispatch(
        GetSummary(
          configuration.configurations,
          configuration.firmwares,
          configuration.releaseHistory,
          familyUnitTypes.unitFamilyId,
          familyUnitTypes.unitTypeId,
          familyUnitTypes.unitVersionId,
          configuration.isMandatoryUpdate,
          id
        )
      ).then(() => {
        this.setState({
          isLoading: false,
        });
      });
    });
  }

  render() {
    if (this.state.isLoading) {
      return <Loader fullpage message="Loading configuration" />;
    }

    return (
      <div class="panel panel-default">
        <div class="panel-heading">
          <h1>View</h1>
          <h3 style={{ display: "inline" }}>Configuration Name: </h3>{" "}
          {this.props.location.configName}
        </div>
        <div class="panel-body">
          <div className="row">
            <div className="col-md-6">
              <div class="form-group">
                <label>Configuration</label>
                <ReactJson
                  src={this.props.configuration}
                  name="configuration"
                  displayDataTypes={false}
                />
              </div>
            </div>
            <div className="col-md-6">
              <div class="form-group">
                <label>Recipe</label>
                <ReactJson
                  src={this.props.recipe}
                  name="recipe"
                  displayDataTypes={false}
                />
              </div>
            </div>
          </div>
          <Button
            className="btn btn-primary pull-right"
            id="btnBack"
            onClick={() => {
              this.props.history.goBack();
            }}
          >
            <Glyphicon glyph="glyphicon glyphicon-arrow-left" />
            Back
          </Button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    configuration: state.configuration.summary.configuration,
    recipe: state.configuration.summary.recipe,
  };
};

export default connect(mapStateToProps)(Details);
